module.exports = __webpack_public_path__ + "img/logo.e194fd6f.png";